module.exports = __webpack_public_path__ + "img/002.872ce891.png";